<div class="pot-input custom-form-control-container">
  <input
    autocomplete="off_off_off"
    class="custom-form-control-input"
    [attr.maxlength]="maxLength"
    [disabled]="isDisabled"
    [ngClass]="{
      'tw-border-2 tw-border-solid tw-border-pl-gray-700': style === InputStyle.withBorders,
      '!tw-border-pl-error !tw-text-pl-error': controlDir?.control?.errors && controlDir?.control?.dirty
    }"
    [placeholder]="placeholder"
    [readonly]="false"
    [type]="type"
    [value]="value"
    (blur)="onTouched()"
    (keyup)="onChange($event)"
  />

  @if (controlDir?.control?.errors && controlDir?.control?.dirty) {
    <div class="pot-custom-form-error-msg">
      @if (controlDir?.control?.errors?.required) {
        <span> This is a required field </span>
      }
      @if (controlDir?.control?.errors?.email) {
        <span> Please enter a valid email address </span>
      }
    </div>
  }
</div>
